import {take, call, fork, put} from 'redux-saga/effects'
import {
  SETTING_ACCOUNT_PAGE_REQUEST,
  SETTING_ACCOUNT_REQUEST
} from 'actions/setting/account/constants'
import {getProfile} from 'sagas/api/profile'
import {settingAccount} from 'sagas/api/account'
import {initialize} from 'redux-form'
import * as mpSettingAccount from 'mixpanel/settings/accounts'

export function * accountPageRequestFlow () {
  while (true) {
    yield take(SETTING_ACCOUNT_PAGE_REQUEST)
    mpSettingAccount.settingAccountStart()
    let profile = yield call(getProfile)
    yield put(initialize('accountForm', {
      'first_name': profile.first_name,
      'last_name': profile.last_name,
      'email': profile.email
    }))
  }
}

export function * settingAccountFlow () {
  while (true) {
    let request = yield take(SETTING_ACCOUNT_REQUEST)
    let data = request.payload.data
    yield call(settingAccount, data)
    yield put(initialize('accountForm', {
      'first_name': data.user.first_name,
      'last_name': data.user.last_name,
      'email': data.user.email
    }))
  }
}

export default function * settingAccountSaga () {
  yield fork(accountPageRequestFlow)
  yield fork(settingAccountFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/setting/account.js